// extracted by mini-css-extract-plugin
export default {"blok":"SpisObszarow_blok__xBU3b","tytul":"SpisObszarow_tytul__PKXgF","siatka":"SpisObszarow_siatka__wPD31"};